(function () {
  var IMAGES = ".tambur-product-card__image";
  var BOXES = ".tambur-product-card__media";
  var MARGIN = 100;
  // Skulle ett foto aldrig komma fram tar vi bort skelettet ändå.
  var MAX_ROLL = 8000;

  function imagesIn(media) {
    return Array.prototype.slice.call(media.querySelectorAll(IMAGES));
  }

  // Fotot som faktiskt syns i rutan. Bild 2 och framåt ligger bakom och väntar.
  function primary(media) {
    return media.querySelector('[data-slide-index="0"] ' + IMAGES);
  }

  function stop(media) {
    media.classList.remove("is-loading");
  }

  // Ger en väntande bild sin adress, med låg prioritet så första fotot går först.
  function wake(img) {
    if (!img || (!img.dataset.src && !img.dataset.srcset)) return;
    img.fetchPriority = "low";
    if (img.dataset.srcset) {
      img.srcset = img.dataset.srcset;
      delete img.dataset.srcset;
    }
    if (img.dataset.src) {
      img.src = img.dataset.src;
      delete img.dataset.src;
    }
  }

  // Bild 2: hover på desktop, nästa svep på mobil.
  function wakeSecond(media) {
    if (media.dataset.rollExtra) return;
    wake(media.querySelector('[data-slide-index="1"] ' + IMAGES));
    media.dataset.rollExtra = "1";
  }

  // Resten av bildspelet, först när någon rör kortet.
  function wakeRest(media) {
    if (media.dataset.rollAll) return;
    media.dataset.rollAll = "1";
    wakeSecond(media);
    imagesIn(media).forEach(wake);
  }

  // Exponera så kategorisidans init kan väcka hover-bilden tidigt
  // (annars syns ingen crossfade förrän IntersectionObserver hunnit köra).
  window.tamburUnveilWakeSecond = wakeSecond;
  window.tamburUnveilWakeRest = wakeRest;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll(BOXES).forEach(wakeSecond);
    return;
  }

  try {
    // Bilden döljs aldrig av oss — skelettet rullar bakom den tills fotot är målat.
    function start(media) {
      if (media.dataset.rollDone) return;
      media.dataset.rollDone = "1";

      var img = primary(media);
      if (!img) return;

      if (img.complete && img.naturalWidth > 0) {
        wakeSecond(media);
        return;
      }

      media.classList.add("is-loading");

      function finish() {
        stop(media);
        wakeSecond(media);
      }

      img.addEventListener("load", finish, { once: true });
      img.addEventListener("error", finish, { once: true });
      setTimeout(finish, MAX_ROLL);
    }

    var io = "IntersectionObserver" in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            start(entry.target);
            io.unobserve(entry.target);
          });
        }, { rootMargin: MARGIN + "px 0px " + MARGIN + "px 0px" })
      : null;

    function watch(root) {
      (root || document).querySelectorAll(BOXES).forEach(function (media) {
        if (media.dataset.rollWatch) return;
        media.dataset.rollWatch = "1";
        media.addEventListener("pointerenter", function () { wakeRest(media); });
        media.addEventListener("touchstart", function () { wakeRest(media); }, { passive: true });
        if (io) io.observe(media);
      });
    }

    function startNearViewport() {
      document.querySelectorAll(BOXES).forEach(function (media) {
        var box = media.getBoundingClientRect();
        if (box.bottom > -MARGIN && box.top < window.innerHeight + MARGIN) start(media);
      });
    }

    var timer;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(startNearViewport, 120);
    }

    watch(document);
    startNearViewport();

    // Väck bild 2 på alla kort direkt så hover-crossfade fungerar utan att
    // vänta på IntersectionObserver/load. Bild 3+ väcks fortfarande vid touch.
    document.querySelectorAll(BOXES).forEach(wakeSecond);

    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);
    window.addEventListener("load", schedule);

    var grid = document.querySelector("[data-collection-grid]");
    if (grid && "MutationObserver" in window) {
      new MutationObserver(function () {
        watch(grid);
        grid.querySelectorAll(BOXES).forEach(wakeSecond);
        schedule();
      }).observe(grid, { childList: true, subtree: true });
    }
  } catch (err) {
    document.querySelectorAll(BOXES).forEach(function (media) {
      stop(media);
      wakeRest(media);
    });
  }
})();
